<template>
  <Teleport to="#flyout">
    <FlyoutComponent v-bind="$attrs" :slots="slots">
      <template #header>
        <slot name="header" />
      </template>
      <template #body>
        <slot />
      </template>
      <template #footer>
        <slot name="footer" />
      </template>
    </FlyoutComponent>
  </Teleport>
</template>

<script setup lang="ts">
const slots = useSlots();
</script>

<script lang="ts">
export default defineComponent({
  name: 'FlyoutPortal',
  inheritAttrs: false,
});
</script>
